import { RichText as RichTextComponent } from '@/ui';
import { prependToNonHttpsHrefs } from '@lib/server';
import { RTEContent } from '@types';

import { BlockBase, Wrapper, getMarginClassNames } from './utils';

export function RichText({
  params,
  id,
  margin,
  ...data
}: {
  richText: RTEContent;
} & BlockBase) {
  const content = params?.venue
    ? prependToNonHttpsHrefs(data.richText?.content, `/${params.venuesPage}/${params.venue}`)
    : data.richText?.content;

  return content ? (
    <Wrapper id={id} className={getMarginClassNames(margin)}>
      <RichTextComponent {...data}>{content}</RichTextComponent>
    </Wrapper>
  ) : null;
}
